import commands from "./commands";
import panels from "./panels";
import style from "./style";
import buildPopup from "./utils/buildPopup";
import buildPanels from "./utils/buildPanels";
import {
  dragElement,
  popupViewportPosition,
  close,
  closeAll,
} from "./utils/helpers";
import { filters, leftPanel } from "./consts";

export default (editor, opts = {}) => {
  const options = {
    ...{
      txtConfirmClear: "Clear Canvas?", // text for confirm exit modal
      filters: filters, // i.e main categories for blocks
      onSave: (editor) => editor.store(),
      onPublish: () => {
        /* Do stuff with html and css */
        editor.runCommand("netlify-dashboard");
      },
      dashboard: () => window.open("/"),
      profile: () => window.open("profile"),
      customStyleManager: [],
      leftPanel: leftPanel,
      logo: "https://blocomposer.app/block-composer.svg",
    },
    ...opts,
  };

  //make forms netlify compatible
  const domc = editor.Components;
  const typeForm = domc.getType("form").model;
  domc.addType("form", {
    model: {
      initTraits() {
        typeForm.prototype.initTraits.apply(this, arguments);
        const tr = this.get("traits");
        [
          {
            name: "name",
            default: "form-name",
          },
          {
            type: "checkbox",
            name: "data-netlify",
            label: "Netlify",
          },
          {
            type: "checkbox",
            name: "netlify-honeypot",
            label: "Honeypot",
            valueTrue: "bot-field",
          },
          {
            type: "checkbox",
            name: "data-netlify-recaptcha",
            label: "CAPTCHA 2",
          },
        ].forEach((trait) => tr.push(trait));
        this.set("traits", tr);
      },
    },
  });

  const btnExp = editor.$(
    '<button id="export-zip-code" class="gjs-btn-prim">Export project .zip</button>'
  );

  editor.on("run:export-template", () => {
    const btn = editor.$("#export-zip-code");
    if (btn.length) {
      editor.Modal.getContentEl().appendChild(btn.get(0));
    } else {
      editor.Modal.getContentEl().appendChild(btnExp.get(0));
      btnExp.on("click", () =>
        editor.runCommand("gjs-export-zip", { save: true })
      );
    }
  });

  // Load commands
  commands(editor, options);
  // Load panels
  panels(editor, options);

  // Do stuff onLoad
  editor.on("load", () => {
    const $ = editor.$;
    //const pn = editor.Panels;
    const pfx = editor.getConfig().stylePrefix;
    const cont = $(editor.getConfig().container);
    const toolbar = $(`#${pfx}tools`);

    toolbar.css("z-index", 2);

    const { popup, openStyleBtn } = buildPopup($, pfx);
    const popupHeading = popup.find(`.${pfx}popup-heading span`).first();

    const { leftPanel, panels, buttons, curves } = buildPanels(
      editor,
      pfx,
      options.leftPanel,
      options.filters
    );

    // Load sm
    style(editor, options);

    // append panels to their respective containers
    toolbar.append(popup);
    toolbar.append(openStyleBtn);
    cont.append(leftPanel);

    // make popup heading interraction point for positioning the popup
    dragElement(popup.get(0), `.${pfx}popup-heading`);

    // recalculate popup position
    editor.on("component:selected component:drag:end", (component) => {
      const { style, classList } = popup.get(0);
      const un = "px";
      const selectedEl =
        (component.getEl && component.getEl()) ||
        (editor.getSelected().getEl && editor.getSelected().getEl()) ||
        toolbar.get(0);

      const { top, left } = popupViewportPosition(
        editor,
        popup.get(0),
        selectedEl,
        {
          offsetTop: 5,
          offsetRight: 5,
        }
      );

      style.top = top + un;
      style.left = left + un;
      classList.add(`${pfx}zoomin`);
      popupHeading.text(
        `${
          (component.getName && component.getName()) ||
          (editor.getSelected() && editor.getSelected().getName())
        } Settings`
      );
      closeAll(panels);
      closeAll(curves);
      closeAll(buttons);
    });
    // make popup visible again to allow it's position to be recalculated
    editor.on("component:deselected", (component) => {
      const { style, classList } = popup.get(0);
      style.display = "block";
      classList.remove(`${pfx}zoomin`);
    });
    // hide left panel in preview mode
    editor.on("run:preview", () => {
      leftPanel.get(0).style.display = "none";
    });
    // show left panel when exit preview mode
    editor.on("stop:preview", () => {
      leftPanel.get(0).style.display = "block";
    });
    // close blocks panel  after 300ms when user starts dragging block
    editor.on("block:drag:start", () => {
      setTimeout(close.bind(this, curves.get(0)), 300);
      setTimeout(close.bind(this, buttons.get(0)), 300);
      setTimeout(close.bind(this, panels.get(0)), 300);
    });
  });
};
